export default __webpack_public_path__ + "static/audiolivehighlight-14f6fb53b537642dcd4e6fb15e98e811.png";